export default "__VITE_ASSET__BcVN52xO__"